import { render, staticRenderFns } from "./test_question.vue?vue&type=template&id=e2627556&scoped=true"
import script from "./test_question.vue?vue&type=script&lang=js"
export * from "./test_question.vue?vue&type=script&lang=js"
import style0 from "./test_question.vue?vue&type=style&index=0&id=e2627556&prod&lang=less&scoped=true"
import style1 from "./test_question.vue?vue&type=style&index=1&id=e2627556&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2627556",
  null
  
)

export default component.exports